import React from "react";




const Miembros = () => {
 return <div className="margin-header"> 
<p>Esto es el cuerpo de la pagina de Miembros</p>
    </div>;
}
;

export default Miembros;
